import { render, staticRenderFns } from "./NavbarLayout.vue?vue&type=template&id=7071a3f4"
import script from "./NavbarLayout.vue?vue&type=script&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&lang=js"
import style0 from "./NavbarLayout.vue?vue&type=style&index=0&id=7071a3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports